export function isValidHttpUrl(s: string) {
    let url;
    try {
        url = new URL(s);
    } catch {
        return false;
    }
    return /https?/.test(url.protocol);
}
